const colors = {
  black: '#000000',
  white: '#EAEAEA',
  red: '#790923',
  violet: '#8C19A3',
  yellow: '#C09537',
  green: '#23994C',
  blue: '#0D39FF',
  offWhite: '#E7E9EA',
  gray: '#7C7C7C',
  darkGray: '#272727',
  lightGreen: '#54988D',
  cyan: '#3da1df',
  pink: '#8e5eec',
} as const

const themeNames = ['light', 'dark'] as const
const colorNames = ['primary', 'secondary', 'contrast', 'border'] as const

const themes = {
  light: {
    primary: colors.white,
    secondary: colors.black,
    contrast: colors.blue,
    border: colors.darkGray,
  },
  dark: {
    primary: colors.black,
    secondary: colors.gray,
    contrast: colors.blue,
    border: colors.darkGray,
  },
} as const satisfies Themes

export { colors, themeNames, themes }

// UTIL TYPES
type Themes = Record<
  (typeof themeNames)[number],
  Record<(typeof colorNames)[number], string>
>
